import { render } from "./LayoutPublic.vue?vue&type=template&id=c74251c0&scoped=true"
import script from "./LayoutPublic.vue?vue&type=script&lang=js"
export * from "./LayoutPublic.vue?vue&type=script&lang=js"

import "./LayoutPublic.vue?vue&type=style&index=0&id=c74251c0&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-c74251c0"

export default script